import { useState } from 'react';

import { SubscriptionTier } from '@invoice-simple/common';

import UserModel, { Cadence } from 'src/models/UserModel';

export const useInterval = (cadence: Cadence | null) => {
  // Check for cadence query parameter
  const urlParams = new URLSearchParams(window.location.search);
  const cadenceParam = urlParams.get('cadence')?.toLowerCase();

  // Determine initial cadence: query param > user's current cadence > default to monthly
  const initialCadence =
    cadenceParam === Cadence.ANNUAL
      ? Cadence.ANNUAL
      : cadenceParam === Cadence.MONTHLY
        ? Cadence.MONTHLY
        : cadence || Cadence.MONTHLY;

  const [selectedInterval, setSelectedInterval] = useState(initialCadence);

  const toggleInterval = (interval: Cadence) => {
    if (interval !== selectedInterval) {
      setSelectedInterval(interval);
    }
  };

  const shouldDisallowSwitch = (destinationTier: SubscriptionTier, user: UserModel) => {
    const userCurrentSubTier = user.activeSubscriptionTier;

    // User is a tiered subscriber
    if (userCurrentSubTier) {
      const userCurrentSubInterval = user.lastActivePaidWebSub(userCurrentSubTier)?.planInterval;
      const isSubscribedToSelectedInterval = userCurrentSubInterval === selectedInterval;
      const isSubscribedToSelectedTier = userCurrentSubTier === destinationTier;
      return isSubscribedToSelectedInterval && isSubscribedToSelectedTier;
    }

    return false;
  };

  return {
    selectedInterval,
    toggleInterval,
    shouldDisallowSwitch
  };
};
